export default "__VITE_ASSET__xAYCzQMK__"